<div class="orders py-3 pagination-order">
  <header
    class="orders-header d-flex align-items-center justify-content-between has-border pb-2">
    <h2>Invoice Email</h2>
    <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="ordersummary-panel ml-auto d-flex justify-content-between">
      <div
        class="form-check form-switch d-flex align-items-center m-0 justify-content-end">
        <div class="d-flex gap-2 align-items-center">
          <p-checkbox
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="copyBcCheckbox"
            inputId="copyBcCheckbox"
            [binary]="true"
            (onChange)="copyBcBAcToGrid('bc')" />
          <label for="copyBcCheckbox"> Copy BC </label>

          <p-checkbox
            id="copyBacCheckbox"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="copyBacCheckbox"
            inputId="copyBacCheckbox"
            [binary]="true"
            (onChange)="copyBcBAcToGrid('bac')" />

          <label for="copyBacCheckbox"> BAC </label>
        </div>
      </div>
    </div>
    <div class="d-flex">
      <div class="ordersummary-panel ml-auto d-flex justify-content-between">
        <div class="nav-link p-0 d-flex align-items-center">
          <a class="link" (click)="onAdd()"><i class="pi pi-plus"></i> Add</a>
        </div>
      </div>
      <div class="ordersummary-panel ml-auto d-flex justify-content-between">
        <div class="ms-3 nav-link p-0 d-flex align-items-center">
          <a class="link delcol" (click)="onDelete()"
            ><i class="pi pi-trash"></i> Delete</a
          >
        </div>
      </div>
    </div>
  </header>
  <p-table
    #dt
    stripedRows
    [value]="invoiceEmailListing"
    [(selection)]="invoiceEmailSelected"
    styleClass="p-datatable-customers ordersLineItems no-wrap table-hover-bg"
    [rowHover]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="false"
    [filterDelay]="0"
    dataKey="id"
    editMode="row"
    [rowHover]="true"
    [rows]="25"
    [showCurrentPageReport]="true"
    [scrollable]="true"
    scrollHeight="calc(100vh - 310px)"
    [size]="'small'"
    selectionMode="multiple"
    styleClass="table-listing">
    <ng-template pTemplate="header">
      <tr class="table-head">
        <th></th>
        <th style="text-align: center">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th class="name">Name</th>
        <th class="purpose">Purpose</th>
        <th class="email">Email</th>
        <th class="save">Save</th>
        <th class="exist">Exist</th>
        <th class="confirmation">Conf</th>
        <th class="confirmation">Inv</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-invoicedEmail
      let-editing="editing"
      let-ri="rowIndex">
      <ng-container>
        <tr class="p-selectable-row" [pEditableRow]="invoicedEmail">
          <td style="text-align: center">
            <p-button
              severity="secondary"
              *ngIf="!editing"
              pButton
              pRipple
              type="button"
              pInitEditableRow
              icon="pi pi-pencil"
              class="p-button-rounded p-button-text"
              (click)="onEditRow(invoicedEmail)" />
            <p-button
              severity="secondary"
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pSaveEditableRow
              icon="pi pi-check"
              class="p-button-rounded p-button-text p-button-success p-mr-2"
              (click)="onSaveRow(invoicedEmail)" />
            <p-button
              severity="secondary"
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pCancelEditableRow
              icon="pi pi-times"
              class="p-button-rounded p-button-text p-button-danger" />
          </td>
          <td class="col-center">
            <p-tableCheckbox [value]="invoicedEmail"></p-tableCheckbox>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  [ngModelOptions]="{ standalone: true }"
                  style="width: 6rem"
                  type="text"
                  [(ngModel)]="invoicedEmail.name"
                  required />
              </ng-template>
              <ng-template pTemplate="output">
                {{ invoicedEmail.name }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <!-- <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  [ngModelOptions]="{ standalone: true }"
                  style="width: 6rem"
                  type="text"
                  [(ngModel)]="invoicedEmail.purpose"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ invoicedEmail.purpose }}
              </ng-template>
            </p-cellEditor> -->

            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-select
                  [appendTo]="'body'"
                  class="invoiceemailoptionstobody"
                  [(ngModel)]="invoicedEmail.purpose"
                  [options]="type"
                  optionLabel="name"
                  optionValue="name">
                </p-select>
              </ng-template>
              <ng-template pTemplate="output">
                {{ invoicedEmail.purpose }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  [ngModelOptions]="{ standalone: true }"
                  style="width: 8rem"
                  type="text"
                  [(ngModel)]="invoicedEmail.email"
                  required />
              </ng-template>
              <ng-template pTemplate="output">
                {{ invoicedEmail.email }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-checkbox
              id="save"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="invoicedEmail.save"
              inputId="save"
              [binary]="true"></p-checkbox>
          </td>
          <td>
            <p-checkbox
              id="exist"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="invoicedEmail.exist"
              inputId="exist"
              [binary]="true"></p-checkbox>
          </td>

          <td>
            <p-checkbox
              id="confirmation"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="invoicedEmail.confirmation"
              inputId="confirmation"
              [binary]="true"></p-checkbox>
          </td>
          <td>
            <p-checkbox
              id="invoice"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="invoicedEmail.invoice"
              inputId="invoice"
              [binary]="true"
              [disabled]="true"></p-checkbox>
          </td>
        </tr>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No line item found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
